import React from "react";
import { useRecoilValue } from "recoil";
import LayerCheckboxList from "../components/LayerCheckboxList";
import LayerGroupCheckboxList from "../components/LayerGroupCheckboxList";
import { layerDefsIDsSelectorForCategory } from "../map/layerAtoms";

const CategoryCheckboxList = ({ category }) => {
  const layerIDsForCategory = useRecoilValue(
    layerDefsIDsSelectorForCategory(category)
  );

  return (
    <>
      {layerIDsForCategory.map((layerID, index) =>
        typeof layerID === "string" ? (
          <LayerCheckboxList key={layerID} layerID={layerID} />
        ) : (
          <LayerGroupCheckboxList key={`group-${index}`} layerIDs={layerID} />
        )
      )}
    </>
  );
};

export default CategoryCheckboxList;
